class MessageParser {
  constructor(actionProvider, state) {
    this.actionProvider = actionProvider;
    this.state = state;
  }

  parse(message) {
    const lowercaseMessage = message.toLowerCase();

    // Handle the user's message by sending it to the action provider
    this.actionProvider.handleUserMessage(message);
  }
}

export default MessageParser;
